import { useTranslations } from "next-intl";
import {
  useBalReturnAvailableFor,
  useReturnPickupCarriersFor,
  useUserShippingAddress,
  useLocalPartnerNameFor,
} from "@hooks/use-addresses";
import { Input, Link } from "@components/core";
import Image from "@components/core/Image";
import carriers from "@utils/constants/carriers";
import { getReturnLink } from "@utils/getReturnLink";

const CollectionModeChoice = ({ onChange, currentMode }) => {
  const t = useTranslations("addresses");

  const userShippingAddress = useUserShippingAddress();
  const balReturnAvailableForCountry = useBalReturnAvailableFor(userShippingAddress?.country);
  const pickupCarriers = useReturnPickupCarriersFor(userShippingAddress?.country);
  const localPartnerNameForCountry = useLocalPartnerNameFor(userShippingAddress?.country);

  function collectionCarrierCard(carrierName) {
    const localPartnerName = localPartnerNameForCountry(carrierName);
    const linkUrl = getReturnLink(carrierName, userShippingAddress?.country);
    const carrierDescriptionKey =
      carrierName === carriers.colissimo && balReturnAvailableForCountry
        ? "colissimo_with_bal_return"
        : localPartnerName;

    return (
      <div
        key={carrierName}
        className="d-flex flex-column mt-3 p-3 w-100 bg-white rounded-lg"
      >
        <div
          key={carrierName}
          className="d-flex justify-content-between"
        >
          <Input
            type="radio"
            label={t(`carrier.${localPartnerName}`)}
            className="font-size-sm m-0"
            checked={currentMode === carrierName}
            value={carrierName}
            onChange={onChange}
          />
          <div>
            <Image
              src={localPartnerName}
              alt={t(`carrier.${localPartnerName}`)}
              style={{ width: "30px", height: "30px" }}
            />
          </div>
        </div>
        <p className="mt-3 mb-0">{t(`collection_form.${carrierDescriptionKey}`)}</p>
        {linkUrl.startsWith("http") && (
          <Link
            className="link-primary mt-3"
            href={linkUrl}
            noUnderline
            target="_blank"
          >
            {t("see_relay_points_list")}
          </Link>
        )}
      </div>
    );
  }

  return (
    <div className="mt-4 d-flex flex-column">
      {pickupCarriers?.map((carrierName) => collectionCarrierCard(carrierName))}
    </div>
  );
};

export default CollectionModeChoice;
